export default __webpack_public_path__ + "static/media/icon-templates-light.d230f6bc.svg";